import { Button } from '@/components/common/Button';
import { entityViewInset } from '@/components/common/EntityView';
import { FlexRow } from '@/components/common/Flex';
import { ArrowLeft } from '@/components/common/icons';

interface OpenIraFlowFooterProps {
    onBack: VoidFunction;
    onNext: VoidFunction;
    nextButtonText?: string;
    isNextDisabled?: boolean;
    isSubmitting?: boolean;
    footerMiddleContent?: JSX.Element;
}

const OpenIraFlowFooter = ({
    onBack,
    onNext,
    nextButtonText = 'Next',
    isNextDisabled,
    isSubmitting,
    footerMiddleContent,
}: OpenIraFlowFooterProps) => {
    return (
        <FlexRow px={entityViewInset} py={4} justifyContent="space-between">
            <Button
                variant="link"
                colorScheme="gray"
                leftIcon={<ArrowLeft />}
                onClick={onBack}
                onClickEvent="Back Button Clicked"
                onClickEventParams={{ location: 'Open IRA Flow Footer' }}
                isDisabled={isSubmitting}
            >
                Back
            </Button>
            {footerMiddleContent}
            <Button
                onClick={onNext}
                isLoading={isSubmitting}
                isDisabled={isSubmitting || isNextDisabled}
                onClickEvent="Next Button Clicked"
                onClickEventParams={{
                    location: 'Open IRA Flow Footer',
                    label: nextButtonText,
                }}
            >
                {nextButtonText}
            </Button>
        </FlexRow>
    );
};

export default OpenIraFlowFooter;
